import { Injectable } from '@angular/core';
import { BaseService } from './base.service';


/*
 *  @author Davi Wegner
 *  @email davi@easypro.com.br
 *  @data 04/03/2021
**/
@Injectable()
export class SchedulingConfigService {

	path = '/scheduling-config';

	constructor(private baseService: BaseService) {}

	post(content) {
		return this.baseService.post(this.path, '', content);
	}

	// getChecklists() {
	// 	return this.baseService.get(this.path, '/checklists');
	// }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/scheduling-config.service.ts